export default __webpack_public_path__ + "static/media/Pick.f8afb450.svg";